import { fmt, pct, type CalcResult } from "@h2lca/core";
import { GlossaryTip } from "../GlossaryTip";
import { IssueList } from "../IssueList";
import { Block, Section } from "../Section";

/** ⑥ 계산과정 확인 , 사용량 × 계수, 단위환산, 합산을 그대로 보인다 */
export function CalcStep({ result }: { result: CalcResult }) {
  return (
    <Section
      title={
        <>
          계산과정 확인 <GlossaryTip k="lci" />
        </>
      }
      desc="각 설비의 사용량 × 배출계수(단위환산 포함), 합산과 배분, 기능단위당 환산 과정을 확인합니다."
      aside={<span className="text-footnote text-ink-subtle">GWP 기준: {result.gwpBasis}</span>}
    >
      <Block title="전력 믹스 구성">
        <div className="table-scroll"><table className="ws-table">
          <thead>
            <tr>
              <th>전력원</th>
              <th className="num">비율</th>
              <th className="num">배출계수 (kgCO2eq/kWh)</th>
              <th className="num">전력량 (kWh)</th>
            </tr>
          </thead>
          <tbody>
            {result.electricity.sources.map((s) => (
              <tr key={s.sourceId}>
                <td>{s.label}</td>
                <td className="num">{pct(s.share)}</td>
                <td className="num">{fmt(s.ef, 4)}</td>
                <td className="num">{fmt(s.kWh)}</td>
              </tr>
            ))}
            <tr>
              <td className="font-semibold">합성 계수</td>
              <td className="num">100%</td>
              <td className="num font-semibold">{fmt(result.electricity.mixEf, 4)}</td>
              <td className="num font-semibold">{fmt(result.electricity.totalKWh)}</td>
            </tr>
          </tbody>
        </table></div>
      </Block>

      <div className="flex flex-col gap-content">
        {result.steps.map((st, i) => (
          <div key={`${st.title}-${i}`} className="rounded-card border border-line-soft bg-panel p-content">
            <h3 className="mb-inline text-caption font-semibold text-ink">{st.title}</h3>
            <ol className="flex flex-col gap-detail font-mono text-footnote text-ink-soft">
              {st.lines.map((l, j) => (
                <li key={j}>{l}</li>
              ))}
            </ol>
          </div>
        ))}
      </div>

      <Block title="검증 메시지">
        <IssueList issues={result.issues} />
      </Block>
    </Section>
  );
}
